import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import {
  getValidToken,
  getStoredToken,
  clearStoredAuth,
  getDefaultRouteForToken,
  getUserTypeFromToken,
  isWaiterRouteAllowed,
  isKitchenRoute,
  getKitchenLoginPath,
} from "@/utils/auth";
import { USER_TYPES } from "@/utils/permissions";


import {
  NotFound,
  Login,
  Home,
  Orders,
  OrderPlace,
  Rooms,
  KitchenTicket,
  KitchenOrders,
  KitchenLogin,
  CustomerTicket,
  Tables,
  Checkout,
  RoomBooking,
  RoomFilter,
  RoomSection,
  ReservedRoomList,
  ReservationDetails,
  ReservationBill,
  TableReservation,
  WaiterDashboard,
} from "@/views/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {},
  },
  {
    path: "/",
    name: "Home",
    component: OrderPlace,
    meta: {},
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/kitchen-tickets",
    name: "Kitchen Tickets",
    component: KitchenTicket,
    meta: {
      auth: false,
    },
  },
  {
    path: "/kitchen/login",
    name: "KitchenLogin",
    component: KitchenLogin,
    meta: { public: true },
  },
  {
    path: "/kitchen/orders",
    name: "KitchenOrders",
    component: KitchenOrders,
    meta: { auth: true, kitchen: true },
  },
  {
    path: "/customer-tickets",
    name: "Customer Tickets",
    component: CustomerTicket,
    meta: {
      auth: false,
    },
  },
  {
    path: "/order/:type/:id",
    name: "Order",
    component: Home,
    meta: {
      auth: false,
    },
  },
  {
    path: "/order/:type",
    name: "Order",
    component: Home,
    meta: {
      auth: false,
    },
  },
  {
    path: "/orders",
    name: "orders",
    component: Orders,
    meta: {
      auth: false,
    },
  },
  {
    path: "/rooms",
    name: "rooms",
    component: Rooms,
    meta: {
      auth: false,
    },
  },
  {
    path: "/rooms-section",
    name: "rooms-section",
    component: RoomSection,
    meta: {
      auth: false,
    },
  },
  {
    path: "/all-rooms",
    redirect: { path: "/rooms-booking", query: { addRooms: "1" } },
  },

  {
    path: "/all-reserved-rooms",
    name: "All Reserved rooms",
    component: ReservedRoomList,
    meta: {
      auth: false,
    },
  },
  {
    path: "/reservation-details/:id",
    name: "Reservation Details",
    component: ReservationDetails,
    meta: {
      auth: false,
    },
  },

  {
    path: "/reservation-details-bill/:id",
    name: "Reservation Bill Details",
    component: ReservationBill,
    meta: {
      auth: false,
    },
  },
  {
    path: "/rooms-filter",
    name: "rooms-filter",
    component: RoomFilter,
    meta: {
      auth: false,
    },
  },
  {
    path: "/rooms-booking",
    name: "roomsBooking",
    component: RoomBooking,
    meta: {
      auth: false,
    },
  },
  {
    path: "/waiter",
    name: "WaiterDashboard",
    component: WaiterDashboard,
    meta: { auth: true, waiter: true },
  },
  {
    path: "/tables",
    name: "tables",
    component: Tables,
    meta: {
      auth: false,
    },
  },
  {
    path: "/checkout/order/:id",
    name: "CheckoutEvent",
    component: Checkout,
    meta: {
      auth: false,
    },
  },
  {
    path: "/checkout-event/order/:id",
    name: "Checkout",
    component: TableReservation,
    meta: {
      auth: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = getValidToken();

  if (!token && getStoredToken()) {
    clearStoredAuth();
    store.commit("auth/SET_STATUS", false);
    store.commit("auth/SET_TOKEN", null);
  }

  if (to.path === "/login") {
    if (token) {
      const redirect = to.query.redirect;
      if (redirect && redirect !== "/login") {
        return next(redirect);
      }
      return next(getDefaultRouteForToken(token));
    }
    return next();
  }

  if (to.path === "/kitchen/login") {
    if (token) {
      const redirect = to.query.redirect;
      if (redirect && redirect !== "/kitchen/login") {
        return next(redirect);
      }
      return next(getDefaultRouteForToken(token));
    }
    return next();
  }

  if (!token) {
    if (isKitchenRoute(to.path)) {
      return next({ path: getKitchenLoginPath(), query: { redirect: to.fullPath } });
    }
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  if (!store.state.auth.status) {
    store.commit("auth/SET_STATUS", true);
  }

  const userType = getUserTypeFromToken(token);
  if (userType === USER_TYPES.KITCHEN && !to.path.startsWith("/kitchen")) {
    return next("/kitchen/orders");
  }
  if (userType === USER_TYPES.WAITER && !isWaiterRouteAllowed(to.path)) {
    return next("/waiter");
  }

  next();
});

export default router;
